import * as React from "react";

function ManufactureSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33.364}
      height={33.253}
      {...props}
    >
      <g fill="#ff7b16">
        <path d="M23.299 4.9h-1.39a5.74 5.74 0 00-.464-.805l.695-1.2a.827.827 0 00-.3-1.13L18.971.111a.827.827 0 00-1.13.3l-.694 1.2a5.453 5.453 0 00-.932 0l-.694-1.2a.827.827 0 00-1.13-.3l-2.865 1.654a.827.827 0 00-.3 1.13l.695 1.2a5.739 5.739 0 00-.464.805h-1.39a.827.827 0 00-.827.827v3.312a.827.827 0 00.827.827h1.39a5.742 5.742 0 00.464.805l-.695 1.2a.827.827 0 00.3 1.13l2.865 1.654a.827.827 0 001.13-.3l.694-1.2a5.426 5.426 0 00.932 0l.694 1.2a.827.827 0 001.13.3L21.838 13a.827.827 0 00.3-1.13l-.695-1.2a5.729 5.729 0 00.464-.805h1.39a.827.827 0 00.827-.827V5.731a.827.827 0 00-.827-.827zm-6.617 4.909a2.427 2.427 0 112.427-2.427 2.43 2.43 0 01-2.427 2.43zM5.289 10.481V8.356h2.007V6.414H4.319a.971.971 0 00-.971.971v3.1a4.208 4.208 0 00-2 7.07.971.971 0 001.373-1.373 2.266 2.266 0 113.2 0 .971.971 0 101.373 1.373 4.208 4.208 0 00-2-7.07zM32.021 11.6a4.179 4.179 0 00-2-1.119v-3.1a.971.971 0 00-.971-.971h-2.982v1.942h2.007v2.125a4.208 4.208 0 00-2 7.07.971.971 0 001.373-1.373 2.266 2.266 0 113.2 0 .971.971 0 101.373 1.373 4.208 4.208 0 000-5.95z" />
      </g>
      <circle
        cx={2.72}
        cy={2.72}
        r={2.72}
        transform="translate(0 27.813)"
        fill="#ff7b16"
      />
      <ellipse
        cx={2.539}
        cy={2.72}
        rx={2.539}
        ry={2.72}
        transform="translate(14.144 27.813)"
        fill="#ff7b16"
      />
      <path
        d="M20.401 27.964a4.517 4.517 0 010 5.178h6.487a4.517 4.517 0 010-5.178zM6.484 27.964a4.517 4.517 0 010 5.178h6.487a4.517 4.517 0 010-5.178z"
        fill="#ff7b16"
      />
      <circle
        cx={2.72}
        cy={2.72}
        r={2.72}
        transform="translate(27.924 27.813)"
        fill="#ff7b16"
      />
      <path
        d="M19.11 20.196h-4.855a.971.971 0 00-.971.971v4.855h6.8v-4.855a.971.971 0 00-.974-.971zM9.4 20.196H4.545a.971.971 0 00-.971.971v4.855h6.8v-4.855a.971.971 0 00-.974-.971zM23.964 20.196a.971.971 0 00-.971.971v4.855h6.8v-4.855a.971.971 0 00-.971-.971z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default ManufactureSvg;
